import { computed, inject } from '@angular/core';
import { tapResponse } from '@ngrx/operators';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { INSTITUTS_MÉTIER } from '@shared/models/instituts-métier';
import { pipe, switchMap } from 'rxjs';

import { Roles } from '../enum/roles.enum';
import { Session, UserService } from './user.service';

interface UserState {
  signedIn: boolean;
  restricted: boolean;
  emailAddress: string | null;
  name: string | null;
  roles: string[];
}

const initialState: UserState = {
  signedIn: true,
  restricted: false,
  emailAddress: null,
  name: null,
  roles: [],
};

export const UserStore = signalStore(
  {
    providedIn: 'root',
  },
  withState(initialState),
  withMethods((store) => ({
    signIn: (state: Omit<UserState, 'restricted'>) => patchState(store, state),
    restrict: () => patchState(store, { restricted: true }),
  })),
  withMethods((store, service = inject(UserService)) => ({
    session: rxMethod<string>(
      pipe(
        switchMap((redirectUrl) =>
          service.session(redirectUrl).pipe(
            tapResponse({
              error: () => store.restrict(),
              next: (data: Session) =>
                data.claims.roles
                  ? store.signIn({
                      signedIn: true,
                      emailAddress: data.claims['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress'],
                      name: data.name,
                      roles: data.claims.roles.split(',') ?? [],
                    })
                  : store.restrict(),
            }),
          ),
        ),
      ),
    ),
  })),
  withComputed((store) => ({
    isAdmin: computed(() => store.roles().includes('ADMIN')),
    canAskValidationEtape: computed(() => store.roles().includes('DEMANDE_VALIDATION_ETAPE')),
    hasNoRole: computed(() => !store.roles().find((x) => Object.keys(Roles).includes(x))),
    instituts: computed(() => store.roles().filter((x) => [...INSTITUTS_MÉTIER].map(([key]) => key).includes(x))),
  })),
);
